/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "africa-diaspora-regions-africa-diaspora-01-blues-bridge-kp-1": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-01-blues-bridge-kp-2": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-01-blues-bridge-kp-3": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-01-blues-bridge-kp-4": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-01-blues-bridge-kp-5": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-02-cuban-bridge-kp-1": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-02-cuban-bridge-kp-2": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-02-cuban-bridge-kp-3": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-02-cuban-bridge-kp-4": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-02-cuban-bridge-kp-5": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-03-brazil-samba-bridge-kp-1": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-03-brazil-samba-bridge-kp-2": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-03-brazil-samba-bridge-kp-3": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-03-brazil-samba-bridge-kp-4": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-03-brazil-samba-bridge-kp-5": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-04-colonial-archives-kp-1": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-04-colonial-archives-kp-2": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-04-colonial-archives-kp-3": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-04-colonial-archives-kp-4": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-04-colonial-archives-kp-5": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-05-listening-across-borders-kp-1": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-05-listening-across-borders-kp-2": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-05-listening-across-borders-kp-3": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-05-listening-across-borders-kp-4": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "africa-diaspora-regions-africa-diaspora-05-listening-across-borders-kp-5": {
    "kind": "none",
    "illustrationPlan": "Africa-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
